/**
 * @file Undoes a credit charge through `charge/:id/uncredit` and confirms it in a snackbar.
 * A refusal the uncredit route is known to send opens the refusal dialog with that path's texts.
 */
import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence, ExpectedErrors } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

const EXPECTED_ERRORS: ExpectedErrors = {
  financial_operations_were_blocked: { titleKey: "refusal-title-uncredit", bodyKey: "refusal-body-financial-processing-busy" },
  cannot_undo_credit_which_was_settled_with_savings: { titleKey: "refusal-title-uncredit", bodyKey: "refusal-body-uncredit-savings" },
  cannot_uncredit_credit_of_direct_charge: { titleKey: "refusal-title-uncredit", bodyKey: "refusal-body-uncredit-direct-charge" },
  cannot_uncredit_non_credit_charges: { titleKey: "refusal-title-uncredit", bodyKey: "refusal-body-uncredit-not-a-credit" }
};

export default function* chargeUndoCredit(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_UNDO_CREDIT_REQUEST
    });

    yield call(Http.put, `charge/${action.payload?.charge?.id}/uncredit`);

    yield put({
      type: Constants.GLOBAL_CHARGE_UNDO_CREDIT_SUCCESS
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-charge-undo-credit-successfully"),
        type: "success"
      }
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action, EXPECTED_ERRORS);

    yield put({
      type: Constants.GLOBAL_CHARGE_UNDO_CREDIT_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeUndoCredit() {
  yield takeEvery(Constants.GLOBAL_CHARGE_UNDO_CREDIT_START, chargeUndoCredit);
}
